import createAction from 'modules/assetLook/actions/_createAction';

export const APPLY_SUMMARY_FIELDS = createAction('APPLY_SUMMARY_FIELDS');
